import _ from 'lodash';
export const fakeRequest = () => {
  return new Promise((resolve) => setTimeout(() => resolve(), 2000));
};

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const getRequestHash = () =>
  window.location.href.split('/')[window.location.href.split('/').length - 1];

export const dataUriToBase64 = (dataUri) => {
  const base64 = dataUri.split('base64,');
  return base64[base64.length - 1];
};

export const branchOfficeGenerator = (branchOffice) => {
  // from branchoffice obj creates an obj with state->counties
  let id = 1;
  const normStates = [];
  const countiesByState = {};
  const officesByCounty = {};
  _.forEach(branchOffice, (office) => {
    // create a normalized array of states
    const state = office.state;
    if (_.find(normStates, (stateObj) => stateObj.value === state)) return;
    const stateObj = {
      id,
      value: state,
      label: _.startCase(_.toLower(state)),
    };
    normStates.push(stateObj);
    // filter branches with that state
    const filteredBranchOffice = _.filter(
      branchOffice,
      (office) => office.state === state
    );
    // create a county holder by state
    countiesByState[state] = countiesByState[state]
      ? countiesByState[state]
      : [];
    // loop through all the offices and collect the normalized counties
    _.forEach(filteredBranchOffice, (filteredStates) => {
      const county = filteredStates.county;
      if (
        _.find(
          countiesByState[state],
          (countyObj) => countyObj.value === county
        )
      )
        return;
      const countyObj = {
        id: id + _.random(0, 10000),
        value: county,
        label: _.startCase(_.toLower(county)),
      };
      countiesByState[state].push(countyObj);

      //filter the branches by state&county
      const filteredOffices = _.filter(
        filteredBranchOffice,
        (office) => office.county === county
      );
      // create a office holder by county
      officesByCounty[county] = officesByCounty[county]
        ? officesByCounty[county]
        : [];
      // loop through all the offices and collect the normalized branch offices
      _.forEach(filteredOffices, (filteredOffice) => {
        const office = filteredOffice.name;
        if (_.find(officesByCounty, (officeObj) => officeObj.value === office))
          return;
        const officeObj = {
          id: filteredOffice.idBranch,
          value: office,
          label: _.startCase(_.toLower(office)),
        };
        officesByCounty[county].push(officeObj);
      });
    });
    id++;
  });

  // normalize branchOffice by id
  const officeById = {};
  _.forEach(branchOffice, (office) => {
    officeById[office.idBranch] = office;
  });

  return { normStates, countiesByState, officesByCounty, officeById };
};

export const parseUserData = (user) => {
  return user;
};

export const base64ToBinary = (dataUrl) => {
  let base64 = dataUrl.split(';').pop();
  if (base64.startsWith('base64,')) base64 = base64.split(',').pop();
  const charCodeAt = (c) => c.charCodeAt(0);
  return new Uint8Array(atob(base64).split('').map(charCodeAt));
};

// format gender

export const formatGender = (gender) => {
  if (gender.toUpperCase() === "MASCULINO") return 'M';
  if (gender.toUpperCase() === "FEMENINO") return 'F';

  return gender.toUpperCase();
}

// parse closing date

export const parseClosingDate = (date) => {

  const closingDate = {
    //Mastercard:
    11: "4to jueves",
    12: "3er jueves",
    13: "2do jueves",
    14: "1er jueves",
    //Visa:
    1: "4to jueves",
    2: "3er jueves",
    3: "2do jueves"
  }

  return closingDate[date];
}